// FALLBACK while the BuildYou script does not tag cross-sell groups itself.
// Intercepts POST /cart/add.js and (1) stamps _bundle_group/_bundle_role/
// _bundle_item_index on main + add-on lines, (2) orders items so the main
// product lands above its add-ons in the cart. Idempotent: items already
// tagged (by the theme or a newer BuildYou script) are left untouched.
// To remove: disable the "Cross-sell" fallback checkbox in theme settings
// (this file is then no longer loaded), or delete this file and its script
// tag in sections/product-detail-page.liquid.
(function () {
  function tagItems(items) {
    if (!Array.isArray(items) || items.length < 2) return items;
    var alreadyTagged = items.some(function (it) {
      return it && it.properties && it.properties._bundle_group;
    });
    if (alreadyTagged) return items;

    var addonIds = (Array.isArray(window.ebUpsell) ? window.ebUpsell : [])
      .filter(function (o) { return o && o.id; })
      .map(function (o) { return String(o.id); });
    if (!addonIds.length) return items;

    var isAddon = function (it) { return it && addonIds.indexOf(String(it.id)) !== -1; };
    var hasAddon = items.some(isAddon);
    var hasMain = items.some(function (it) { return it && it.id && !isAddon(it); });
    if (!hasAddon || !hasMain) return items;

    var groupId = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
      ? crypto.randomUUID()
      : Date.now() + '-' + Math.random().toString(36).slice(2, 10);

    var addonIndex = 0;
    return items.map(function (it) {
      if (!it || !it.id) return it;
      var props = Object.assign({}, it.properties || {});
      props._bundle_group = groupId;
      if (isAddon(it)) {
        addonIndex += 1;
        props._bundle_role = 'addon';
        props._bundle_item_index = String(it.index || addonIndex);
      } else {
        props._bundle_role = 'main';
        props._bundle_item_index = '0';
      }
      return Object.assign({}, it, { properties: props });
    });
  }

  function orderItems(items) {
    var role = function (it) { return (it && it.properties && it.properties._bundle_role) || ''; };
    var mains = items.filter(function (it) { return role(it) === 'main'; });
    var addons = items.filter(function (it) { return role(it) === 'addon'; });
    if (!mains.length || !addons.length) return items;
    var others = items.filter(function (it) { return role(it) !== 'main' && role(it) !== 'addon'; });
    var idx = function (it) { return parseInt(it.properties._bundle_item_index, 10) || 0; };
    var sortedAddons = addons.slice().sort(function (a, b) { return idx(b) - idx(a); });
    return others.concat(sortedAddons).concat(mains);
  }

  function tagBody(body) {
    try {
      var data = JSON.parse(body);
      if (!data || !Array.isArray(data.items)) return body;
      data.items = orderItems(tagItems(data.items));
      return JSON.stringify(data);
    } catch (e) {
      return body;
    }
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (isCartAddUrl(url) && init && typeof init.body === 'string') {
        init = Object.assign({}, init, { body: tagBody(init.body) });
      }
    } catch (e) {}
    return origFetch.call(this, input, init);
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartAdd = String(method).toUpperCase() === 'POST' && isCartAddUrl(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__isCartAdd && typeof body === 'string') {
      body = tagBody(body);
    }
    return origSend.call(this, body);
  };
})();
